import { MouseEventHandler } from "react";
import BybPerformanceChip from "@Components/common/byb-ds/byb-performance-chip";
import { DecisionScoreCardContainer } from "@Components/game/session-results/decision/styled-components";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import { Box, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import StarIcon from "@Resources/app/icons-v2/system-icons/star-icon";

interface IDecisionScoreCard {
  loading?: boolean;
  title?: string;
  score?: number;
  showScore?: boolean;
  isBestOption?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
  onMouseEnter?: MouseEventHandler<HTMLElement>;
}

const DecisionScoreCard = ({
  loading = false,
  title = "",
  score = 0,
  showScore = false,
  isBestOption = false,
  isSelected = false,
  onClick,
  onMouseEnter,
}: IDecisionScoreCard) => {
  const theme = useTheme();

  if (loading) {
    return (
      <DecisionScoreCardContainer isSelected={false} theme={theme} onClick={onClick} onMouseEnter={onMouseEnter} isLoading>
        <Stack flex={1} direction="row" spacing={2} alignItems="center" justifyContent="space-between">
          <Skeleton variant="text" width="40%" height={24} />
          <Skeleton variant="text" width="20%" height={24} />
        </Stack>
      </DecisionScoreCardContainer>
    );
  }

  return (
    <DecisionScoreCardContainer isSelected={isSelected} theme={theme} onClick={onClick} onMouseEnter={onMouseEnter}>
      <Stack flex={1} direction="row" spacing={1} alignItems="center" justifyContent="space-between">
        <Typography variant="textLg600" color="dsBase.v200" noWrap>
          {title}
        </Typography>

        {showScore && (
          <Stack direction="row" gap={2} alignItems="center" position="relative">
            {isBestOption && (
              <Box border={`${theme.spacing(0.1)} solid ${theme.palette.dsSurface.v300}`} borderRadius={10} padding={1.5} width={20} height={20}>
                <StarIcon color={theme.palette.warning.main} size={20} />
              </Box>
            )}
            <BybPerformanceChip score={score} metricKey={MetricFilterTypes.DECISION} showAbsoluteValue />
          </Stack>
        )}
      </Stack>
    </DecisionScoreCardContainer>
  );
};

export default DecisionScoreCard;
